import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import { SelectButton } from 'primereact/selectbutton';
import './stylesCardSetting.css';
import Strings from '../../../../../i18n';

interface CardSportSettingProps {
  sportSetting: any;
  minTimeExecute: Date;
  maxTimeExecute: Date;
  onResetMinMaxTime: () => void;
  onEdited: (updatedSetting: any) => void;
}

export const CardSportSetting = ({
  sportSetting,
  minTimeExecute,
  maxTimeExecute,
  onResetMinMaxTime,
  onEdited
}: CardSportSettingProps) => {
  const [actualDate, setActualDate] = useState(new Date());
  const stateOptions = [
    { label: 'Off', value: '0' },
    { label: 'On', value: '1' }
  ];

  const SPORT_SETTINGS_VALUE_TYPE = {
    int: 'int',
    time: 'time',
    bool: 'bool'
  };

  const setValuesForTimeType = () => {
    const time = sportSetting.value.split(':');
    const hour = +time[0];
    const minute = +time[1];
    const seconds = +time[2] || 0;
    const newDate = new Date();
    newDate.setHours(hour, minute, seconds);
    setActualDate(newDate);
  };

  const saveTime = (newDate: Date) => {
    setActualDate(newDate);

    const updatedSetting = {
      ...sportSetting,
      value: `${String(newDate.getHours()).padStart(2, '0')}:${String(
        newDate.getMinutes()
      ).padStart(2, '0')}:${String(newDate.getSeconds()).padStart(2, '0')}`
    };

    onEdited(updatedSetting);
    onResetMinMaxTime();
  };

  const saveIntValue = (newDate: Date) => {
    setActualDate(newDate);

    const updatedSetting = {
      ...sportSetting,
      value: (newDate.getHours() * 60 + newDate.getMinutes()).toString()
    };

    onEdited(updatedSetting);
  };

  const handleBooleanChange = (value: string) => {
    const updatedSetting = {
      ...sportSetting,
      value
    };
    onEdited(updatedSetting);
  };

  const toHoursAndMinutes = (totalMinutes: number) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const newDate = new Date();
    newDate.setHours(hours, minutes, 0);
    setActualDate(newDate);
  };

  const setValuesForDialogs = () => {
    if (sportSetting.valueType === SPORT_SETTINGS_VALUE_TYPE.int) {
      toHoursAndMinutes(parseInt(sportSetting.value, 10));
    } else if (sportSetting.valueType === SPORT_SETTINGS_VALUE_TYPE.time) {
      setValuesForTimeType();
    }
  };

  useEffect(() => {
    setValuesForDialogs();
  }, [sportSetting]);

  return (
    <div className="container-setting">
      <div className="title-setting">
        <h4 className="title-sport">{sportSetting.name}</h4>
      </div>
      <div className="info-setting">
        {sportSetting.valueType === SPORT_SETTINGS_VALUE_TYPE.int && (
          <div className="row">
            <div className="col-12 time-picker-container text-center container-calendar">
              <Calendar
                value={actualDate}
                onChange={(e) => saveIntValue(e.value as Date)}
                timeOnly
                readOnlyInput
              />
              <div className="label-text">
                <span>{Strings.sports.hours}</span>
              </div>
            </div>
          </div>
        )}

        {sportSetting.valueType === SPORT_SETTINGS_VALUE_TYPE.time && (
          <div className="row">
            <div className="col-12 text-center container-calendar">
              {sportSetting.key === 'SEST' ? (
                <>
                  <Calendar
                    value={actualDate}
                    onChange={(e) => saveTime(e.value as Date)}
                    timeOnly
                    showSeconds
                    maxDate={maxTimeExecute}
                    readOnlyInput
                  />
                  <div className="label-text">
                    <span>{Strings.sports.start}</span>
                  </div>
                </>
              ) : (
                <>
                  <Calendar
                    value={actualDate}
                    onChange={(e) => saveTime(e.value as Date)}
                    timeOnly
                    showSeconds
                    minDate={minTimeExecute}
                    readOnlyInput
                  />
                  <div className="label-text">
                    <span>{Strings.sports.stop}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {sportSetting.valueType === SPORT_SETTINGS_VALUE_TYPE.bool && (
          <div className="row">
            <div className="col-12 text-center mb-3">
              <SelectButton
                value={sportSetting.value}
                options={stateOptions}
                onChange={(e) => handleBooleanChange(e.value)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
